import React, { Component } from 'react';
import { replace } from 'react-router-redux';
import config from 'config';

const _showError = (e, target, superRenderError, renderArgs = []) => {
  if (superRenderError) {
    return superRenderError(...renderArgs);
  }

  let pathname;
  const {
    context: {
      store: {
        getState,
        dispatch: storeDispatch
      } = {}
    } = {},
    props: {
      dispatch = storeDispatch,
      location: {
        pathname: propsPath
      } = {}
    } = {}
  } = target;

  if (getState) {
    ({
      routing: {
        locationBeforeTransitions: {
          pathname = propsPath
        } = {}
      } = {}
    } = getState());
  }

  if (!pathname) {
    pathname = "/$unknown";
  }

  if (pathname == "/") {
    pathname = "/$home-page";
  }

  if (!config.isProduction) {
    console.error(e); // eslint-disable-line no-console
  }

  const title = "Server Error";
  const errorPixelSrc = `/1x1.gif?type=page&id=${title}&cb=${Date.now()}`;

  return <div>
    <img src={errorPixelSrc} width="1" height="1" />
  </div>;
}

function _wrapError(e, target, methodName) {
  target._classInError = Object.assign(e, {
    message: `${e.message} (from ${methodName})`,
    from: methodName
  });
}



export default function catchLifeCycleErrors(ComponentClass) {
  if (!Component.isPrototypeOf(ComponentClass)) {
    throw new Error("Cannot catch lifecycle methods of something that isn't a React Component");
  }

  class Decorated extends ComponentClass {
    // TODO add error handling to the constructor
    constructor(...args) {
      super(...args);
      this._classInError = false;
    }

    componentWillMount(...args) {
      if (super.componentWillMount) {
        try {
          super.componentWillMount(...args);
        }
        catch (e) {
          _wrapError(e, this, "componentWillMount");
        }
      }
    }

    componentDidMount(...args) {
      if (super.componentDidMount) {
        try {
          super.componentDidMount(...args);
        }
        catch (e) {
          _wrapError(e, this, "componentDidMount");
        }
      }
    }

    componentWillReceiveProps(...args) {
      if (super.componentWillReceiveProps) {
        try {
          super.componentWillReceiveProps(...args);
        }
        catch (e) {
          _wrapError(e, this, "componentWillReceiveProps");
        }
      }
    }

    componentWillUpdate(...args) {
      if (super.componentWillUpdate) {
        try {
          super.componentWillUpdate(...args);
        }
        catch (e) {
          _wrapError(e, this, "componentWillUpdate");
        }
      }
    }

    componentDidUpdate(...args) {
      if (super.componentDidUpdate) {
        try {
          super.componentDidUpdate(...args);
        }
        catch (e) {
          _wrapError(e, this, "componentDidUpdate");
        }
      }
    }

    componentWillUnmount(...args) {
      if (super.componentWillUnmount) {
        try {
          super.componentWillUnmount(...args);
        }
        catch (e) {
          _wrapError(e, this, "componentWillUnmount");
        }
      }
    }

    shouldComponentUpdate(...args) {
      if (super.shouldComponentUpdate) {
        try {
          return !!super.shouldComponentUpdate(...args);
        }
        catch (e) {
          _wrapError(e, this, "shouldComponentUpdate");
          return false;
        }
      }

      return true;
    }

    render(...args) {
      if (this._classInError) {
        return _showError(this._classInError, this, super.renderError);
      }

      if (super.render) {
        try {
          return super.render(...args);
        }
        catch (e) {
          return _showError(e, this, super.renderError, args);
        }
      }
    }
  }


  return Decorated
}



// WEBPACK FOOTER //
// ./utils/catchLifeCycleErrors.js